import { fetchWithAuth } from '../helpers';

const handleResponse = async (response: Response) => {
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
  return response.json();
};

const saveGameCompletion = async (studentId: number, setId: number, gameType: 'quiz' | 'matching', completionTimeMs: number, score?: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/flashcard-leaderboard/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': '69420',
    },
    body: JSON.stringify({
      student_id: studentId,
      set_id: setId,
      game_type: gameType,
      completion_time_ms: completionTimeMs,
      ...(score !== undefined && { score }), // Only include score if provided
    }),
  });
  return handleResponse(response);
};

const getLeaderboard = async (setId: number, gameType: 'quiz' | 'matching') => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/flashcard-leaderboard/board/${setId}/${gameType}`, {
    method: 'GET',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(response);
};

const getStudentBestTime = async (studentId: number, setId: number, gameType: 'quiz' | 'matching') => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/flashcard-leaderboard/student/${studentId}/${setId}/${gameType}`, {
    method: 'GET',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(response);
};

export const leaderboardService = {
  saveGameCompletion,
  getLeaderboard,
  getStudentBestTime,
};
